import gql from "graphql-tag";

const GET_AUTH_USER_POOL_QUIZ = gql`
    query getAuthUserPoolQuiz {
        getAuthUserPoolQuiz {
            poolId
            quizzes {
                quizId
                numberOfAttempts
                lastAttempt {
                    id
                    start_time
                    end_time
                    isSuccessful
                    score
                    last_answered_question_id
                }
            }
        }
    }
`

export default GET_AUTH_USER_POOL_QUIZ;